import StorageService from '@/services/storage.service'
import storageKeys from '@/constants/storageKeys'
import { defaultFilters } from '@/models/SpendsParsingLog/helpers'
import spendsParsingLogRepository from '@/repository/generatedRepository/spendsParsingLogRepository'
import TableOptions from '@/models/TableOptions'
import { omitEmptyDeepFilters, prepareFilters } from '@/helpers/filters'
import { downloadExportFile } from '@/helpers/export'
import { DATE_FORM_FORMAT } from '@/constants/date'
const { saveAs } = require('file-saver')
import moment from 'moment'

const state = {
  list: [],
  filters: StorageService.get(storageKeys.SPENDS_PARSING_LOG_FILTERS) || { ...defaultFilters() },
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  list: state => state.list,
  isOpenFilterPanel: state =>
    state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
}

const actions = {
  async loadData(context, payload) {
    const { signal, ...filters } = payload
    context.commit('setFilters', filters)
    StorageService.set(storageKeys.SPENDS_PARSING_LOG_FILTERS, filters)

    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)
    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
      signal,
    })
    if (filters.sortBy.includes('createdBy')) {
      preparedFilters.order = {
        createdBy: {
          name: filters.sortDesc[0] ? 'DESC' : 'ASC',
        },
      }
    }
    const { data } = await spendsParsingLogRepository.list(preparedFilters)

    context.commit('setList', { data, filters })

    return { products: data.items, pagination: data.pagination }
  },
  async loadExportFile(context, filters) {
    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)
    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
    })
    if (filters.sortBy?.includes('createdBy')) {
      preparedFilters.order = {
        createdBy: {
          name: filters.sortDesc[0] ? 'DESC' : 'ASC',
        },
      }
    }
    await downloadExportFile(spendsParsingLogRepository.exportSpendsParsingLogToken(preparedFilters))
  },
  async searchSpendsParsingLog(context, filters) {
    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
    })

    const { data } = await spendsParsingLogRepository.list(preparedFilters)

    return { products: data.items, pagination: data.pagination }
  },
  async loadItem(context, id) {
    const { data } = await spendsParsingLogRepository.get(id)
    return data
  },
  createItem(context, payload) {
    return spendsParsingLogRepository.post(payload)
  },
  updateItem(context, payload) {
    const { id, ...data } = payload
    return spendsParsingLogRepository.put(id, data)
  },
  deleteItem(context, payload) {
    return spendsParsingLogRepository.delete(payload)
  },
  filtersStorageReset() {
    StorageService.remove(storageKeys.SPENDS_PARSING_LOG_FILTERS)
  },
  resetSearchFilter({ commit }) {
    commit('clearSearch')
  },
  async downloadResponse(context, { id, ...payload }) {
    const response = await spendsParsingLogRepository.downloadFile(id)
    const blob = new Blob([response.data], { type: response.headers['content-type'] })
    saveAs(blob, `response_${moment(payload.createdAt).format(DATE_FORM_FORMAT)}.txt`)
    return response
  },
  updateFiltersClientOptions({ commit, getters }, clientOptions) {
    const updatedFilters = {
      ...getters.filters,
      clientOptions,
    }
    commit('setFilters', updatedFilters)
    StorageService.set(storageKeys.SPENDS_PARSING_LOG_FILTERS, updatedFilters)
  },
}

const mutations = {
  setList(state, { data, filters }) {
    state.list = [...data.items]
    state.tableOptions = new TableOptions(data.pagination, filters)
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
  clearSearch(state) {
    state.tableOptions.search = ''
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
